import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ParagraphTag from "../../reusebale/Paragraph";
import PlanSection from "../profile-complete/plans";

import * as AuthAction from "../../../store/actions/auth/AuthAction";

import db from "../../../db/index.json";
import { useNavigate } from "react-router-dom";

const PlanStatus = ({ onButtonClick, isComplete }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { completeProfileData } = db;
  const { userCompleteProfile } = useSelector((state) => state.auth);

  const [profielPercentage, setProfilePercentage] = useState(1);

  useEffect(() => {
    if (userCompleteProfile) {
      if (
        userCompleteProfile.personalInformation &&
        userCompleteProfile.companyInformation
        // && userCompleteProfile.bankInformation
      ) {
        setProfilePercentage(100);
        setTimeout(() => {
          isComplete();
        }, 1000);
      } else if (
        userCompleteProfile.personalInformation &&
        userCompleteProfile.companyInformation
      ) {
        setProfilePercentage(80);
      } else if (
        userCompleteProfile.personalInformation ||
        userCompleteProfile.companyInformation
      ) {
        setProfilePercentage(40);
      } else {
        setProfilePercentage(1);
      }
    }
  }, [userCompleteProfile, isComplete]);

  const handleLogout = () => {
    dispatch(AuthAction.LogoutAction());
    navigate("/login", { replace: true });
  };

  return (
    <div className="w-full pt-4">
      <button
        onClick={handleLogout}
        className="absolute top-4 right-4 flex items-center gap-2 px-4 py-2 font-popinsRegular text-sm rounded-lg transition-colors duration-200"
      >
        <img
          src="/assets/daashboard/logout-icon.png"
          alt="Logout"
          className="w-8 h-8"
        />
        <ParagraphTag
          content={"Logout"}
          classes="font-popinsSemiBold text-lg pl-3"
        />
      </button>
      <div>
        <ParagraphTag
          content={completeProfileData?.complete}
          classes="text-darkColor font-popinsSemiBold text-xl"
        />

        <ParagraphTag
          content={completeProfileData?.profileDesc}
          classes="text-[#686868] font-popinsRegular text-sm w-[45%] pt-1"
        />
        <div class="w-[100%] h-4 mb-4 bg-[#E6BF9F33] rounded-full dark:bg-[#E6BF9F33] mt-4">
          <div
            className="h-4 bg-themeColor rounded-full"
            style={{ width: `${profielPercentage}%` }}
          ></div>
        </div>
      </div>
      <PlanSection onButtonClick={onButtonClick} isComplete={isComplete} />
    </div>
  );
};

export default PlanStatus;
